import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import logoFull from "../../../assets/images/cricket-logo.png";
import {
  passwordReset,
  publicOtpSend,
  publicResetPassword,
  publicVerifyOtp,
} from "../../../services/publicService";

function ForgetPassword() {
  const navigate = useNavigate();

  const [step, setStep] = useState(1);

  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [errors, setErrors] = useState({
    email: "",
    otp: "",
    password: "",
    confirmPassword: "",
  });

  // Send OTP
  const sendOtp = async (e) => {
    e.preventDefault();

    let error = { email: "", otp: "", password: "", confirmPassword: "" };

    if (!email.trim()) {
      error.email = "Email is required";
      setErrors(error);
      return;
    }

    setErrors(error);

    try {
      const payload = {
        email: email,
      };
      const res = await publicOtpSend(payload);
      console.log(res);
      if (res) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "OTP sent successfully.",
        });

        setStep(2);
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.response?.data?.message || "Failed to send OTP.",
      });
    }
  };

  // Verify OTP
  const verifyOtp = async (e) => {
    e.preventDefault();

    let error = { email: "", otp: "", password: "", confirmPassword: "" };

    if (!otp.trim()) {
      error.otp = "OTP is required";
      setErrors(error);
      return;
    }

    if (otp.length !== 6) {
      error.otp = "Please enter valid 6 digit OTP";
      setErrors(error);
      return;
    }

    setErrors(error);

    try {
      const payload = {
        email: email,
        otp: otp,
      };

      const res = await publicVerifyOtp(payload);

      console.log(res);

      if (res) {
        Swal.fire({
          icon: "success",
          title: "OTP Verified",
          text: "OTP verified successfully.",
        });

        setStep(3);
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.response?.data?.message || "Failed to send OTP.",
      });
    }
  };

  // Reset Password
  const resetPassword = async (e) => {
    e.preventDefault();

    let error = {
      email: "",
      otp: "",
      password: "",
      confirmPassword: "",
    };

    if (!password) {
      error.password = "Password is required";
    }

    if (!confirmPassword) {
      error.confirmPassword = "Confirm Password is required";
    }

    if (password && confirmPassword && password !== confirmPassword) {
      error.confirmPassword = "Password and Confirm Password do not match";
    }

    setErrors(error);

    if (error.password || error.confirmPassword) {
      return;
    }

    try {
      const payload = {
        email: email,
        otp: otp,
        password: password,
        confirmPassword: confirmPassword,
      };

      const res = await publicResetPassword(payload);

      console.log(res);

      if (res) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: "Password changed successfully.",
        }).then(() => {
          navigate("/login");
        });
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err?.response?.data?.message || "Failed to send OTP.",
      });
    }
  };

  return (
    <div className="fix-wrapper">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-5 col-md-6">
            <div className="card mb-0 h-auto">
              <div className="card-body">
                <div className="text-center mb-3">
                  <Link to="/login">
                    <img src={logoFull} alt="logo" width="150" height="140" />
                  </Link>
                </div>

                <h4 className="text-center mb-4">Forgot Password</h4>

                {/* STEP 1 */}
                {step === 1 && (
                  <form onSubmit={sendOtp}>
                    <div className="mb-3">
                      <label className="form-label">Email</label>

                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter Email"
                        value={email}
                        onChange={(e) => {
                          setEmail(e.target.value);
                          setErrors({
                            ...errors,
                            email: "",
                          });
                        }}
                      />

                      {errors.email && (
                        <div className="text-danger mt-1">{errors.email}</div>
                      )}
                    </div>

                    <button className="btn btn-primary w-100" type="submit">
                      Send OTP
                    </button>
                  </form>
                )}

                {/* STEP 2 */}
                {step === 2 && (
                  <form onSubmit={verifyOtp}>
                    <div className="mb-3">
                      <label className="form-label">OTP</label>

                      <input
                        type="text"
                        maxLength={6}
                        className="form-control"
                        placeholder="Enter 6 Digit OTP"
                        value={otp}
                        onChange={(e) => {
                          setOtp(e.target.value.replace(/\D/g, ""));

                          setErrors({
                            ...errors,
                            otp: "",
                          });
                        }}
                      />

                      {errors.otp && (
                        <div className="text-danger mt-1">{errors.otp}</div>
                      )}
                    </div>

                    <button className="btn btn-primary w-100" type="submit">
                      Verify OTP
                    </button>
                  </form>
                )}

                {/* STEP 3 */}
                {step === 3 && (
                  <form onSubmit={resetPassword}>
                    <div className="mb-3">
                      <label className="form-label">New Password</label>

                      <input
                        type="password"
                        className="form-control"
                        placeholder="Enter New Password"
                        value={password}
                        onChange={(e) => {
                          setPassword(e.target.value);
                          setErrors({
                            ...errors,
                            password: "",
                            confirmPassword: "",
                          });
                        }}
                      />

                      {errors.password && (
                        <div className="text-danger mt-1">
                          {errors.password}
                        </div>
                      )}
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Confirm Password</label>

                      <input
                        type="password"
                        className="form-control"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => {
                          setConfirmPassword(e.target.value);
                          setErrors({
                            ...errors,
                            confirmPassword: "",
                          });
                        }}
                      />

                      {errors.confirmPassword && (
                        <div className="text-danger mt-1">
                          {errors.confirmPassword}
                        </div>
                      )}
                    </div>

                    <button className="btn btn-primary w-100" type="submit">
                      Reset Password
                    </button>
                  </form>
                )}

                <div className="text-center mt-4">
                  <Link to="/login">Back to Login</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ForgetPassword;
